module.exports = __webpack_public_path__ + "static/media/25.3dd59e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/25.jpg
// module id = 715
// module chunks = 0